export default "__VITE_ASSET__4cc1dd12__"